export enum PriceDuration {
	Monthly = 1,
	Yearly = 2,
}
